// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nb-notification-dropdown {
    position: absolute;
    top: 60px;
    right: 200px;
    background-color: var(--card-bg, rgb(4, 4, 4));
    color: white;
    font-family: Arial, Helvetica, sans-serif;
    border: 1px solid var(--border-color, rgb(52, 51, 51));
    width: 300px;
    /* box-shadow: 0 4px 12px rgba(0,0,0,0.1); */
    border-radius: 6px;
    z-index: 1000;
    padding: 10px;
  }

  .notif-item {
    padding: 8px;
    cursor: pointer;
    /* border-bottom: 1px solid #eee; */
  }
  
  /* .notif-item:hover {
    background-color: gray;
  } */
  
  .notif-item.unread {
    background-color: black;
    font-weight: 500;
    color: white;
  }
  
  .notif-item.unread:hover {
    background: gray;
  }

  .notif-msg {
    display: block;
    margin-bottom: 4px;
  }
  
  .notif-time {
    font-size: 12px;
    color: #666;
  }
  
  .empty {
    text-align: center;
    padding: 20px;
    color: #999;
  }
  `, "",{"version":3,"sources":["webpack://./src/components/common/Navbar/NotificationDropdown.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,SAAS;IACT,YAAY;IACZ,8CAA8C;IAC9C,YAAY;IACZ,yCAAyC;IACzC,sDAAsD;IACtD,YAAY;IACZ,4CAA4C;IAC5C,kBAAkB;IAClB,aAAa;IACb,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,eAAe;IACf,mCAAmC;EACrC;;EAEA;;KAEG;;EAEH;IACE,uBAAuB;IACvB,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,WAAW;EACb","sourcesContent":[".nb-notification-dropdown {\n    position: absolute;\n    top: 60px;\n    right: 200px;\n    background-color: var(--card-bg, rgb(4, 4, 4));\n    color: white;\n    font-family: Arial, Helvetica, sans-serif;\n    border: 1px solid var(--border-color, rgb(52, 51, 51));\n    width: 300px;\n    /* box-shadow: 0 4px 12px rgba(0,0,0,0.1); */\n    border-radius: 6px;\n    z-index: 1000;\n    padding: 10px;\n  }\n\n  .notif-item {\n    padding: 8px;\n    cursor: pointer;\n    /* border-bottom: 1px solid #eee; */\n  }\n  \n  /* .notif-item:hover {\n    background-color: gray;\n  } */\n  \n  .notif-item.unread {\n    background-color: black;\n    font-weight: 500;\n    color: white;\n  }\n  \n  .notif-item.unread:hover {\n    background: gray;\n  }\n\n  .notif-msg {\n    display: block;\n    margin-bottom: 4px;\n  }\n  \n  .notif-time {\n    font-size: 12px;\n    color: #666;\n  }\n  \n  .empty {\n    text-align: center;\n    padding: 20px;\n    color: #999;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
